export default "__VITE_ASSET__irr8y0ll__"